/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: manual_task.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CountMyManualTasksRequest,
  CountMyManualTasksResponse,
  CreateManualTaskRequest,
  CreateManualTaskResponse,
  DeleteManualTaskRequest,
  DeleteManualTaskResponse,
  GetManualTaskRequest,
  GetManualTaskResponse,
  ListCaseManualTasksRequest,
  ListCaseManualTasksResponse,
  ListManualTasksRequest,
  ListManualTasksResponse,
  ListMyManualTasksRequest,
  ListMyManualTasksResponse,
  ListOrganizationManualTasksRequest,
  ListOrganizationManualTasksResponse,
  UpdateManualTaskRequest,
  UpdateManualTaskResponse,
} from '../types/manual_task';

export const createManualTaskService = (transport: Transport) => ({
  async createManualTask(
    request: CreateManualTaskRequest,
    options: RequestOptions = {},
  ): Promise<CreateManualTaskResponse> {
    const { organization_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.CreateManualTask, {
      organization_id,
      user_id,
    });
    return transport.post<CreateManualTaskResponse>(url, body, options);
  },

  async getManualTask(
    request: GetManualTaskRequest,
    options: RequestOptions = {},
  ): Promise<GetManualTaskResponse> {
    const { organization_id, user_id, manual_task_id } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.GetManualTask, {
      organization_id,
      user_id,
      manual_task_id,
    });
    return transport.get<GetManualTaskResponse>(url, options);
  },

  async listManualTasks(
    request: ListManualTasksRequest,
    options: RequestOptions = {},
  ): Promise<ListManualTasksResponse> {
    const { organization_id, user_id, ...params } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.ListManualTasks, {
      organization_id,
      user_id,
    });
    return transport.get<ListManualTasksResponse>(url, { params, ...options });
  },

  async updateManualTask(
    request: UpdateManualTaskRequest,
    options: RequestOptions = {},
  ): Promise<UpdateManualTaskResponse> {
    const { organization_id, manual_task_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.UpdateManualTask, {
      organization_id,
      manual_task_id,
      program_id,
    });
    return transport.post<UpdateManualTaskResponse>(url, body, options);
  },

  async listMyManualTasks(
    request: ListMyManualTasksRequest,
    options: RequestOptions = {},
  ): Promise<ListMyManualTasksResponse> {
    const url = getApiPath(API_METHODS.ManualTaskService.ListMyManualTasks);
    return transport.get<ListMyManualTasksResponse>(url, { params: request, ...options });
  },

  async countMyManualTasks(
    request: CountMyManualTasksRequest,
    options: RequestOptions = {},
  ): Promise<CountMyManualTasksResponse> {
    const url = getApiPath(API_METHODS.ManualTaskService.CountMyManualTasks);
    return transport.get<CountMyManualTasksResponse>(url, { params: request, ...options });
  },

  async listOrganizationManualTasks(
    request: ListOrganizationManualTasksRequest,
    options: RequestOptions = {},
  ): Promise<ListOrganizationManualTasksResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.ListOrganizationManualTasks, {
      organization_id,
    });
    return transport.get<ListOrganizationManualTasksResponse>(url, { params, ...options });
  },

  async listCaseManualTasks(
    request: ListCaseManualTasksRequest,
    options: RequestOptions = {},
  ): Promise<ListCaseManualTasksResponse> {
    const { organization_id, program_id, case_record_id, ...params } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.ListCaseManualTasks, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.get<ListCaseManualTasksResponse>(url, { params, ...options });
  },

  async deleteManualTask(
    request: DeleteManualTaskRequest,
    options: RequestOptions = {},
  ): Promise<DeleteManualTaskResponse> {
    const { organization_id, user_id, manual_task_id } = request;
    const url = getApiPath(API_METHODS.ManualTaskService.DeleteManualTask, {
      organization_id,
      user_id,
      manual_task_id,
    });
    return transport.delete<DeleteManualTaskResponse>(url, options);
  },
});

export type ManualTaskService = ReturnType<typeof createManualTaskService>;
